import { callFunction } from "./functions-client";

// Pro subscriptions (Stripe Checkout + Customer Portal, via the billing function).
export interface BillingStatus {
  status: string;
  plan: string | null;
  current_period_end: string | null;
  active: boolean;
  /** First-1,000 launch promo — holds a founding slot (whether or not the free year is still active). */
  founding_member: boolean;
  /** True while the founding member is still inside their free year. */
  founding_active: boolean;
  /** ISO date the founding free year ends (founding_since + 1 year), or null if not founding. */
  founding_until: string | null;
  /** True when the account may post without paying (founding free year active OR active Pro). */
  can_post_free: boolean;
  /** Whether the Pro paywall is live yet (turns on automatically once the 1,000-member cap is hit). */
  enforced: boolean;
  configured: boolean;
}

export const getBillingStatus = () => callFunction<BillingStatus>("billing/status", { method: "GET" });
export const startCheckout = () => callFunction<{ url: string }>("billing/checkout", { body: {} });
export const syncCheckout = (session_id: string) =>
  callFunction<{ status: string; active: boolean }>("billing/sync", { body: { session_id } });
export const openPortal = () => callFunction<{ url: string }>("billing/portal", { body: {} });

export interface Invoice {
  id: string;
  number: string | null;
  created: number;
  amount: number;
  currency: string;
  status: string;
  description: string;
  hosted_invoice_url: string | null;
  invoice_pdf: string | null;
}
export const getInvoices = () => callFunction<{ invoices: Invoice[] }>("billing/invoices", { method: "GET" });

export interface PaymentMethod {
  id: string;
  brand: string;
  last4: string;
  exp_month: number | null;
  exp_year: number | null;
}
export interface Charge {
  id: string;
  created: number;
  amount: number;
  currency: string;
  status: string;
  description: string;
}
export const getPayments = () => callFunction<{ methods: PaymentMethod[]; charges: Charge[] }>("billing/payments", { method: "GET" });

/** Format Stripe minor units (cents) as a currency string. */
export function money(amount: number, currency = "usd"): string {
  return new Intl.NumberFormat(undefined, { style: "currency", currency: currency.toUpperCase() }).format(amount / 100);
}
